enum AuthorizationOdontoStatusEnum {
	FINISHED = 'CONCLUIDO',
	UNDER_ANALYSIS = 'EM ANALISE DA AUDITORIA ODONTOLOGICA',
	PENDING = 'ITENS PENDENTES',
	REJECTED = 'INDEFERIDO',
	CANCELED = 'CANCELADO',
	UNFORMATTED_FINISHED = 'Concluido',
	UNFORMATTED_UNDER_ANALYSIS = 'Em analise da auditoria odontologica',
}

export {AuthorizationOdontoStatusEnum};
